import CustomError from './CustomError'

export default class TokenExpiredException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
